//changing background color
export const lightBlueThemeColor='#acc7e4';
export const darkBlueThemeColor='#236bb9';
